import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { checkChapterHasGame } from '../../../../../ui/src/common/book/BookHelpers';

const MyLittleFunBookChapterView: React.FC<{ chapter: any; index: number }> = ({
  chapter,
  index,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChangeChapter = () => {
    searchParams.delete('chapter');
    searchParams.set('chapter', chapter.id);
    setSearchParams(searchParams);
  };
  return (
    <div
      className={`box-chapter chapter-${chapter.id} chapter-${index} ${
        checkChapterHasGame(chapter) ? 'active' : 'chapter-disabled'
      }`}
      onClick={handleChangeChapter}
    />
  );
};

export default MyLittleFunBookChapterView;
